import { MockFactory } from '@tino-frontend/mocks'
import {
  CheckUnicoResultResponse,
  CheckUnicoResultResponseResult,
} from '@types'

export const CheckUnicoResultResponseFailedMock =
  new MockFactory<CheckUnicoResultResponse>({
    result: CheckUnicoResultResponseResult.FAILED,
  })
